<template>

    <div class="container-fluid fixcontent " >

        <div class="row " style="margin-top: 1px; margin-bottom: -4px !important;" >
            <div class="col-md-2 text-light " style="padding-left: 0px !important;">
                <img class="col-md-12   " src="@/assets/images/headerlogo.png"   >
            </div>
            <div class="col-md-6 text-center col-7 mt-4 text-light offset-1 font-weight-semi-bold" style="font-size: 17px">
                <welcomenote/>

            </div>
            <div class="col-md-3 text-right col-4 text-light mt-1" style="font-size: 17px" >
                <p style="margin-bottom: 0.3rem"><ShowRealTime/></p>
                <a class="text-light" href="#" @click.prevent="signOut" >Login</a> / <a class="text-light" href="#" @click.prevent="signOut">Logout</a>
            </div>
        </div>

        <div class="row mt-2">
            <sidebar></sidebar>
            <div class="col-md-11 bgsecond mt-2 text-light">

                <div class="row  mt-2">



                    <div class="col-md-2 ">
                     <h1>Claims</h1>
                    </div>

                    <div class="col-md-2">
                        <b-input v-model="claimfilters.order_id"
                                 @input="()=>{
                                 this.claimfilters.page=1;
                                 this.get_claims()
                              }"
                                 placeholder="Order ID"></b-input>
                    </div>
                    <div class="col-md-2">
                        <b-input v-model="claimfilters.customer_name"
                                 @input="()=>{
                                 this.claimfilters.page=1;
                                 this.get_claims()
                              }"
                                 placeholder="Name"></b-input>
                    </div>
                    <div class="col-md-2">
                        <b-input v-model="claimfilters.phone_number"
                                 @input="()=>{
                                 this.claimfilters.page=1;
                                 this.get_claims()
                              }"
                                 placeholder="Mobile"></b-input>
                    </div>


                    <div class="col-md-2">
                        <v-select
                            v-model="claimfilters.branch_id"
                            @input="()=>{
                                 this.claimfilters.page=1;
                                 this.get_claims()
                              }"
                            class="text-dark"
                            placeholder="Branch"
                            :options="branches"

                            label="name"
                            :reduce="option => option.id"

                        />
                    </div>
                    <div class="col-md-2">
                        <v-select
                            v-model="claimfilters.status"
                            @input="()=>{
                                 this.claimfilters.page=1;
                                 this.get_claims()
                              }"
                            class="text-dark"
                            placeholder="Status"
                            :options="['Pending','Approved','Completed']"

                        />
                    </div>





                    <!--                    <b-table id="customers-table"  class="bg-light" :items="filteredCustomers" :fields="fields" striped hover responsive :per-page="perPage" :current-page="currentPage">-->


                    <!--                        <template #cell(actions)="data">-->

                    <!--                            <b-link class="" :to="{ path: '/customerform',query: { type: 'edit', 'id': data.item.id } }">-->
                    <!--                                <b-button class="btn-info mb-2" > Edit </b-button>-->
                    <!--                            </b-link>-->
                    <!--                            <b-link class="mx-1" :to="{ path: '/customerform',query: { type: 'view', 'id': data.item.id } }">-->
                    <!--                                <b-button class="btn-info mb-2" > View </b-button>-->
                    <!--                            </b-link>-->
                    <!--&lt;!&ndash;                            <b-link class="mx-1" :to="{ path: '/customerform',query: { type: 'view', 'id': data.item.id } }">&ndash;&gt;-->
                    <!--&lt;!&ndash;                                <b-button class="btn-info mb-2" > Orders </b-button>&ndash;&gt;-->
                    <!--&lt;!&ndash;                            </b-link>&ndash;&gt;-->

                    <!--                        </template>-->

                    <!--                    </b-table>-->
                    <!--                    <b-pagination-->
                    <!--                        class=""-->
                    <!--                        v-model="currentPage"-->
                    <!--                        :total-rows="customers.length"-->
                    <!--                        :per-page="perPage"-->
                    <!--                        aria-controls="customers-table"-->
                    <!--                    ></b-pagination>-->
                </div>
                <div class="row mt-2" >
                    <div class="col-md-2">
                                                <button class="btn-sm btn-info" @click="get_claims()">
                                                    <span v-if="showloader" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                    Refresh
                                                </button>
                    </div>
                    <div class="col-md-2">

                    </div>
                    <div class="col-md-1">
                        <button class="btn-sm btn-info"     :disabled="claims?.current_page==1" @click="get_paged_data('prev')">Previous</button>
                    </div>
                    <div class="col-md-3">
                        <span class="text-light mx-2 px-2" v-if="!showloader" style="border: 3px solid white; border-radius: 5px"> showing  ( <span v-if="claims?.to-50>0">{{claims?.to-50}}</span> <span v-else="">0</span>  to {{claims.to}}) out of {{claims.total}} records</span>
                    </div>
                    <div class="col-md-1">

                        <button class="btn-sm btn-info "    :disabled="claims?.current_page==totalPages" @click="get_paged_data('next')">Next</button>
                    </div>
                    <div class="col-md-2 ">

                    </div>

                    <!--                    <div class="col-md-2 text-right">-->
                    <!--                        <button class="btn-sm btn-warning"    @click="clearfilters" >Clear Filters</button>-->
                    <!--                    </div>-->

                </div>
                <div class="row mt-1">
                    <div v-if="showloader" class="col-md-10 offset-1 text-center">
                        <loader/>
                    </div>
                </div>
                <div class="row mt-2">
                    <table class="table table-bordered table-striped text-light">
                        <thead class="thead-dark">
                        <tr>
                            <!--                            <th>Id</th>-->
                            <th>Order ID</th>
                            <th>Name</th>

                            <th>Mobile</th>
                            <th>Email</th>
                            <th>Address</th>
                            <th>Branch</th>
                            <th>User Delivery Date</th>
                            <th>System Delivery Date</th>
<!--                            <th>Reported to Driver?</th>-->
                            <th>Reported?</th>
                            <th>Mode</th>
                            <th>Status</th>
                            <th>Claim Amount</th>
                            <th>Claiming Website</th>
                            <th>Description</th>
                            <th>Images</th>



                            <th class="text-center">Actions</th>
                        </tr>
                        </thead>
                        <tbody id="customerTableBody">
                        <tr v-for="claim in claims.data">
                            <td :class="claim.invoice?'':'text-danger'"
                                :title="claim.invoice ? '' : 'Invoice did not exist for this Order ID'"
                            >{{claim.invoice_id}}</td>
                            <td>{{claim.customer_name}}</td>
                            <td>{{claim.phone_number}}</td>
                            <td>{{claim.email}}</td>
                            <td>{{claim.address}}</td>
                            <td>{{branches.find((b)=>b.id==claim.branch_id).name}}</td>
                            <td>{{formatDate(claim.delivery_date)}}</td>
                            <td>{{ formatDate(claim.invoice?.deliveryDate || claim.invoice?.issueDate) }}</td>
<!--                            <td> {{claim.damage_reported_to_driver==1?'Yes':'No'}} </td>-->
                            <td> {{claim.delivery_note_damaged_signed==1?'Yes Reported':'Not Reported'}} </td>

                            <td>{{claim.delivery_mode}}</td>
                            <td>{{claim.claim_status}}</td>
                            <td>{{claim.claim_amount}}</td>
                            <td>{{claim.claiming_website}}</td>
                            <td>{{claim.description}}</td>
                            <template>
                                <td>

                                    <template v-for="(image, index) in claim.images">
                                        <a
                                            v-if="index !== 0"
                                            :key="'hidden-' + index"
                                            :href="claim.claiming_website === 'Right Tiles' ? `${RTO_URL}/images/claims/damage/${image.name}` : claim.claiming_website === 'Order Tiles' ? `${OTO_URL}/images/claims/damage/${image.name}` : ''"
                                            :data-fancybox="'gallery-claim-' + claim.id"
                                            data-caption="Claim Image"
                                            style="display: none;"
                                        ></a>
                                    </template>


                                    <a
                                        v-if="claim.images.length"
                                        :href="claim.claiming_website === 'Right Tiles' ? `${RTO_URL}/images/claims/damage/${claim.images[0].name}` : claim.claiming_website === 'Order Tiles' ? `${OTO_URL}/images/claims/damage/${claim.images[0].name}` : ''"
                                        :data-fancybox="'gallery-claim-' + claim.id"
                                        data-caption="Claim Image"
                                        class="btn btn-info btn-sm mx-1"
                                    >
                                        View
                                    </a>
                                </td>
                            </template>






                                                        <td class="text-center">
<!--                                <b-link class="" :to="{ path: '/customerform',query: { type: 'edit', 'id': claim.id } }">-->
<!--                                    <b-button class="btn-info mb-2" > Edit </b-button>-->
<!--                                </b-link>-->
<!--                                <b-link class="mx-1" :to="{ path: '/customerform',query: { type: 'view', 'id': claim.id } }">-->
<!--                                    <b-button class="btn-info mb-2" > View </b-button>-->
<!--                                </b-link>-->
                                                            <b-button @click="showmodal(claim)" v-if="authenticatedUser.permissions.includes('super') && claim.claim_status==='Approved'" :disabled="saving" class="btn-success mb-2 mx-1"> Complete </b-button>
                                                            <b-button @click.prevent="showmodal(claim)" v-if="claim.claim_status==='Pending'" :disabled="saving" class="btn-success mb-2 mx-1"> Approve </b-button>
                                                            <span @click="showmodal(claim,true)" v-if="claim.claim_status==='Completed' || claim.claim_status==='Approved'"  class="  mx-1"> <i class="bi bi-eye"></i> </span>
                                                            <b-button @click.prevent="showmodal(claim)" v-if="claim.claim_status==='Approved' && !authenticatedUser.permissions.includes('super')" :disabled="saving" class="btn-success mb-2 mx-1"> Edit </b-button>
                                                            <b-button @click="rejectclaim(claim.id)" v-if="claim.claim_status==='Pending'" :disabled="saving" class="btn-info mb-2 mx-1"> Reject </b-button>
                                                            <b-button @click="create_invoice(claim)" v-if="claim.claim_status==='Completed' && !claim.claimed_invoice_id && !authenticatedUser.permissions.includes('super')" :disabled="saving" class="btn-info mb-2 mx-1"> Create Invoice </b-button>
                                                            <b-button @click="loadorder(claim.claimed_invoice_id)" v-if="claim.claim_status==='Completed' && claim.claimed_invoice_id && !authenticatedUser.permissions.includes('super')" :disabled="saving" class="btn-info mb-2 mx-1">load:   <span v-if="loading_order" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> {{ claim.claimed_invoice_id}} </b-button>
                                                            <b-button @click="deleteclaim(claim.id)" v-if="authenticatedUser.permissions.includes('super') && claim.claim_status!=='Approved' && claim.claim_status!=='Completed'" :disabled="saving" class="btn-danger mb-2"> Delete </b-button>


                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <b-modal  v-model="claim_modal" hide-footer  centered size="xl"  v-if="selected_claim">
                        <div class="row">
                            <div class="col-md-12">
                                <h1 class="text-center mb-4" >Claim Details</h1>

                                <div class="row mb-4" v-if="selected_claim">
                                    <div class="col-md-6">
                                        <div class="card bg-light border-0 shadow-sm h-100">
                                            <div class="card-body">
                                                <div class="d-flex align-items-center mb-3">
                                                    <div class="icon-box mr-3" :class="reportedStatus.color">
                                                        <i :class="reportedStatus.icon" style="font-size: 1.5rem;"></i>
                                                    </div>
                                                    <div>
                                                        <small class="text-muted d-block text-uppercase font-weight-bold">Reported Status</small>
                                                        <span :class="['badge', reportedStatus.badge, 'px-3', 'py-2']" style="font-size: 0.9rem;">
                                                            {{ reportedStatus.text }}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div class="d-flex align-items-center">
                                                    <div class="icon-box mr-3" :class="deliveryStatus.color">
                                                        <i :class="deliveryStatus.icon" style="font-size: 1.5rem;"></i>
                                                    </div>
                                                    <div>
                                                        <small class="text-muted d-block text-uppercase font-weight-bold">Delivery Status</small>
                                                        <span :class="['badge', deliveryStatus.badge, 'px-3', 'py-2']" style="font-size: 0.9rem;">
                                                            {{ deliveryStatus.status }}
                                                        </span>
                                                        <div v-if="deliveryStatus.isLate" class="mt-1 small text-danger font-italic">
                                                            Claimed {{ deliveryStatus.days }} days after delivery.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="card bg-light border-0 shadow-sm h-100">
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-6 border-right">
                                                        <small class="text-muted d-block text-uppercase font-weight-bold">User Delivery Date</small>
                                                        <span :class="['font-weight-bold', 'h6', datesMismatch ? 'text-danger' : '']">{{ formatDate(selected_claim.delivery_date) }}</span>
                                                    </div>
                                                    <div class="col-6 pl-4">
                                                        <small class="text-muted d-block text-uppercase font-weight-bold">System Delivery Date</small>
                                                        <span :class="['font-weight-bold', 'h6', datesMismatch ? 'text-danger' : '']">{{ formatDate(selected_claim.invoice?.deliveryDate || selected_claim.invoice?.issueDate) }}</span>
                                                    </div>
                                                </div>
                                                <div class="row mt-3">
                                                    <div class="col-6 border-right">
                                                        <small class="text-muted d-block text-uppercase font-weight-bold">Order ID</small>
                                                        <span class="font-weight-bold h5 text-primary">#{{ selected_claim.invoice_id }}</span>
                                                    </div>
                                                    <div class="col-6 pl-4">
                                                        <small class="text-muted d-block text-uppercase font-weight-bold">Delivery Mode</small>
                                                        <span class="font-weight-bold h6">{{ selected_claim.delivery_mode }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <table class="table table-bordered text-dark" >
                                    <thead>
                                    <tr>
                                        <!--                           <th>ID</th>-->

                                        <th>ItemCode</th>

                                        <th>Description </th>
                                         <th>  Qty  </th>
                                        <th> UnitPrice </th>
                                        <th> SubTotal </th>


                                    </tr>
                                    </thead>
                                    <tbody >

                                    <tr  v-for="item in selected_claim.invoice.items">


                                        <td >{{item.pivot.itemCode}} </td>

                                        <td>{{item.pivot.itemDescription}} </td>
                                        <td>{{item.pivot.quantity}} </td>
                                        <td>{{Number(item.pivot.unitPrice).toFixed(2)}} </td>
                                        <td>{{Number(item.pivot.subtotal).toFixed(2)}} </td>





                                    </tr>

                                    </tbody>
                                </table>
                                <table class=" col-md-4 table table-bordered text-dark" >
                                    <thead>
                                    <tr>


                                        <th>Order Sub Total</th>

                                        <th>Vat</th>
                                        <th>  Total Paid </th>



                                    </tr>
                                    </thead>
                                    <tbody >
                                    <tr>
                                        <td>{{selected_claim.invoice.subTotal}}</td>
                                        <td>{{selected_claim.invoice.vat}}</td>
                                        <td>{{selected_claim.invoice.totalPaid}}</td>
                                    </tr>

                                    </tbody>
                                </table>

                                <div class="row">
                                    <div class="col-md-12">
                                        <label for="manager-notes" class="font-weight-bold">Manager Notes</label>
                                        <b-form-textarea
                                            v-model="selected_claim.manager_notes"
                                            id="manager-notes"
                                            placeholder="Enter notes"
                                            rows="3"
                                            :disabled="is_view_only"
                                        ></b-form-textarea>
                                    </div>



                                </div>


                                <div class="row mt-3">
                                    <div class="col-md-12">
                                        <h3 class="text-center">Approved Items</h3>
                                        <table class="table table-bordered text-dark">
                                            <thead>
                                            <tr>
                                                <th>Item Code</th>
                                                <th>Description</th>
                                                <th>Broken Tiles</th>
                                                <th>Qty</th>
                                                <th>Unit Price</th>
                                                <th>Total</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(item, index) in approved_items" :key="index">
                                                <td class="col-md-3">
                                                    <div class="d-flex align-items-center">
                                                        <i v-if="!is_view_only" class="bi bi-x-circle text-danger cursor-pointer mr-2" @click="removeApprovedItem(index)"></i>
                                                        <b-input v-model="item.itemCode" autocomplete="off" list="invoice-items-list" @change="updateApprovedItem(index)" :disabled="is_view_only"></b-input>
                                                    </div>
                                                </td>


                                                <td>
                                                    <b-input v-model="item.itemDescription" disabled></b-input>
                                                </td>
                                                <td class="col-md-1">
                                                    <b-input v-model="item.broken_tiles" disabled></b-input>
                                                </td>
                                                <td class="col-md-1">
                                                    <b-input v-model="item.quantity" type="number" @input="calculateItemSubtotal(index)" :disabled="is_view_only"></b-input>
                                                </td>
                                                <td class="col-md-2">
                                                    <b-input v-model="item.unitPrice" type="number" @input="calculateItemSubtotal(index)" :disabled="is_view_only"></b-input>
                                                </td>
                                                <td class="col-md-2">
                                                    <b-input :value="item.subtotal" disabled></b-input>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="6">
                                                    <div class="d-flex align-items-center">
                                                         <i v-if="approved_items.length < selected_claim.invoice.items.length && !is_view_only" class="bi bi-plus-circle text-success cursor-pointer" style="font-size: 1.5rem" @click="addApprovedItem()"></i>
                                                         <span class="ml-auto font-weight-bold" style="margin-left: -15px" >Vat:{{(grandTotal*0.2).toFixed(2)}} Total: {{ grandTotal }}={{ (Number(grandTotal) + Number(grandTotal) * 0.2).toFixed(2) }}</span>
                                                    </div>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                        <datalist id="invoice-items-list">
                                            <option v-for="item in availableInvoiceItems" :key="item.id" :value="item.pivot.itemCode">
                                                {{ item.pivot.itemDescription }}
                                            </option>
                                        </datalist>
                                    </div>
                                </div>

                                <div class="row mt-2">
                                    <div class="col-md-2 offset-md-4">
                                        <label for="credit-amount" class="font-weight-bold">Credit Amount</label>
                                        <b-input
                                            v-model="selected_claim.claim_amount"
                                            id="credit-amount"
                                            placeholder="credit amount"
                                            type="number"
                                            :class="
                                              (Math.round(Number(selected_claim.claim_amount) * 100)) >
                                              (Math.round((Number(grandTotal) * 1.2) * 100))
                                                ? 'text-danger'
                                                : 'text-dark'
                                            "
                                            :disabled="is_view_only"
                                        ></b-input>
                                    </div>
                                    <div class="col-md-2 ">

                                        <label for="" class="font-weight-bold">Employee</label>
                                        <b-form-select
                                            v-model="selected_claim.cashier_id"
                                            :options="cashiers"

                                            :disabled="is_view_only"
                                            :state="selected_claim.cashier_id!=null"


                                            value-field="id"
                                            text-field="fullName"
                                        >

                                            <template #first>
                                                <b-form-select-option :value="null">Select Employee</b-form-select-option>
                                            </template>
                                            <template #option="{ option }">
                                                <div>{{ option.fullName }}</div>
                                            </template>

                                        </b-form-select>

                                    </div>
                                </div>





                                <div class="d-flex justify-content-center mt-3">
                                    <button
                                        v-if="!authenticatedUser.permissions.includes('super') && !is_view_only"
                                        class="btn btn-success d-flex align-items-center"
                                        @click="approveclaim(selected_claim.id)"
                                        :disabled="saving || !selected_claim.claim_amount || !hasValidApprovedItems"
                                    >


                                        <span v-if="selected_claim.claim_status=='Approved'">Re Approve</span>
                                        <span v-else>Approve</span>
                                        <span v-if="saving" class="saving-dots ml-1">
                                      <span></span><span></span><span></span>
                                   </span>

                                    </button>

                                    <button
                                        v-if="authenticatedUser.permissions.includes('super') && !is_view_only"
                                        class="btn btn-success d-flex align-items-center"
                                        @click="approveclaim(selected_claim.id)"
                                        :disabled="saving || !selected_claim.claim_amount || !hasValidApprovedItems"
                                    >

                                        <span v-if="selected_claim.claim_status=='Approved'">Re Approve</span>
                                        <span v-else>Approve</span>
                                        <span v-if="saving" class="saving-dots ml-1">
                                      <span></span><span></span><span></span>
                                   </span>

                                    </button>

                                    <button
                                        v-if="authenticatedUser.permissions.includes('super') && !is_view_only"
                                        class="btn btn-success d-flex align-items-center mx-1"
                                        @click="completeclaim(selected_claim.id)"
                                        :disabled="saving  || !selected_claim.claim_amount || !hasValidApprovedItems"
                                    >

                                        <span>Complete</span>
                                        <span v-if="saving" class="saving-dots ml-1">
                                      <span></span><span></span><span></span>
                                   </span>

                                    </button>

                                    <button class="btn btn-primary hide" ></button>
                                    <button class="btn btn-secondary me-5" @click="claim_modal = false">{{ is_view_only ? 'Close' : 'Cancel' }}</button>
                                </div>
                            </div>
                        </div>
                    </b-modal>
                </div>



            </div>

        </div>

    </div>

</template>

<script>
//import apiService from "@/service/apiService";
import { mapActions } from "vuex";
import { mapGetters } from 'vuex';
import { mapState } from 'vuex';
import sidebar from "@/components/layout/sidebar";
import showrealtime from "@/components/showrealtime";
import vSelect from "vue-select";
import Welcomenote from "@/pages/admin/mypos/welcomenote.vue";
import URL from "@/constants/baseurl";
import Loader from "@/components/loader.vue";
import moment from "moment/moment";
//import vSelect from "vue-select";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import apiService from "@/service/apiService";
import Swal from "sweetalert2";
import axios from "axios";
import {cloneDeep} from 'lodash'
import newinvoice from "@/constants/newinvoice";


export default {
    name: "claims",

    components:{Loader, Welcomenote, 'v-select': vSelect,'sidebar': sidebar,'ShowRealTime':showrealtime},
    computed: {
        ...mapGetters(['AuthenticatedUser']),
        ...mapState('claims',['claimfilters']),
        //  ...mapState('customers', ['customers']), not using this state
        ...mapState('invoice', ['branches','cashiers']),
        ...mapState('dispatch',['newtransaction','transactionshistory']),
        ...mapState('items',['searched_items']),
        totalPages() {
            const perpage = this.claims.per_page;
            const total=this.claims.total;

            return Math.ceil(total / perpage);
        },
        authenticatedUser() {
            let user = localStorage.getItem('user');
            user = JSON.parse(user)
            return user
        },
        availableInvoiceItems() {
            if (this.selected_claim && this.selected_claim.invoice && this.selected_claim.invoice.items) {
                const approvedCodes = this.approved_items.map(i => i.itemCode);
                return this.selected_claim.invoice.items.filter(item => !approvedCodes.includes(item.pivot.itemCode));
            }
            return [];
        },
        hasValidApprovedItems() {
            return this.approved_items.some(item => item.itemCode !== '');
        },
        grandTotal() {
            return this.approved_items.reduce((acc, item) => acc + Number(item.subtotal || 0), 0).toFixed(2);
        },
        deliveryStatus() {
            if (!this.selected_claim || !this.selected_claim.delivery_date) return null;
            let deliveryDate = new Date(this.selected_claim.delivery_date);
            let claimDate = new Date(this.selected_claim.created_at);
            deliveryDate.setHours(0,0,0,0);
            claimDate.setHours(0,0,0,0);
            let diffTime = claimDate - deliveryDate;
            let diffDays = diffTime / (1000 * 60 * 60 * 24);
            return {
                isLate: diffDays > 3,
                days: Math.floor(diffDays)-1,
                status: diffDays > 3 ? 'Out of Delivery Date' : 'Within Delivery Period',
                color: diffDays > 3 ? 'text-danger' : 'text-success',
                badge: diffDays > 3 ? 'badge-danger' : 'badge-success',
                icon: diffDays > 3 ? 'bi-exclamation-triangle-fill' : 'bi-check-circle-fill'
            };
        },
        reportedStatus() {
            if (!this.selected_claim) return null;
            let isReported = this.selected_claim.delivery_note_damaged_signed == 1;
            return {
                text: isReported ? 'Yes Reported' : 'Not Reported',
                color: isReported ? 'text-success' : 'text-danger',
                badge: isReported ? 'badge-success' : 'badge-danger',
                icon: isReported ? 'bi-megaphone-fill' : 'bi-megaphone'
            };
        },
        datesMismatch() {
            if (!this.selected_claim || !this.selected_claim.delivery_date) return false;
            const userDate = moment(new Date(this.selected_claim.delivery_date)).startOf('day');
            const systemDate = moment(new Date(this.selected_claim.invoice?.deliveryDate || this.selected_claim.invoice?.issueDate)).startOf('day');
            return !userDate.isSame(systemDate);
        }


    },


    data() {
        return {
            saving:false,
            loading_order:false,
            // RTO_URL:'http://127.0.0.1:8185',
            RTO_URL:'https://righttiles.co.uk',
            OTO_URL:'http://127.0.0.1:8186',
            roles: [],
            user: {},
            // perPage:100,
            // currentPage: 1,
            claims:[],
            showloader:false,

            claim_modal:false,
            selected_claim:null,
            approved_items: [],
            is_view_only: false,


            // cashier_id:'',
            // order_status:'',
            // branch_id:'',
            // searchcustname:'',
            // searchcustphone:'',
            // searchcustemail:'',
            // custtype:'',
            // credit:true,

            // fields: [
            //
            //     { key: 'lastName', label: 'Name' },
            //     { key: 'mobile', label: 'Mobile' },
            //     { key: 'customerType', label: 'Customer Type' },
            //     { key: 'email', label: 'Email' },
            //     { key: 'walletBalance', label: 'Balance' },
            //     'actions'
            //
            // ],

        };
    },
    async created() {

        //  await this.getUsers();
        //   await this.getRoles();
        // await this.getbranches()
        // await this.getcashiers()

        const promises = [

            this.reloadcb(),
            this.get_claims(),

        ];
        await Promise.all(promises);

    },
    async mounted() {
        Fancybox.bind("[data-fancybox]", {});

    },
    updated() {

        Fancybox.bind("[data-fancybox]", {});
    },
    methods: {
        ...mapActions('payment', ['setNewpayment']),
        ...mapActions(['login', 'processLogoutManual']),
        ...mapActions('invoice', ['getbranches','updateFullInvoice','getcashiers']),
        ...mapActions('items', ['attachapprovedclaimitems']),
        ...mapActions('notes',['attachinvoicenotes']),
        ...mapActions('dispatch',['add_dis_items','attach_invoice_transactions']),
        ...mapActions('invoice', ['getLatestInvoices']),
        ...mapActions('items', ['attachinvoiceitems']),



        async rejectclaim(id){

                const result = await Swal.fire({
                    title: 'Are you sure you want to reject this claim?',
                    text: 'This action cannot be undone.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, reject it!',
                });
                if (result.isConfirmed) {

                    const apiToken = localStorage.getItem('token');
                    if (apiToken) {
                        // Set the Authorization header with the API token
                        axios.defaults.headers.common['Authorization'] = `Bearer ${apiToken}`;
                    }
                    try {
                        this.saving=true
                        const res = await axios.post(`${URL.BASEURL}/api/reject-claim/${id}`);

                        if (res) {

                          // this.claims.data= this.claims.data.map((c)=>{
                          //    if(c.id===res.id) {
                          //        return res
                          //    } else {
                          //        return c
                          //    }
                          // })

                            Swal.fire('success', 'Claim Rejected', 'success');
                            await  this.get_claims()

                        } else {
                            Swal.fire('info', 'Claim Cant be Reject', 'info');
                        }
                    } catch (error) {
                        console.error(error);
                        Swal.fire('Error', 'Failed to Approve Claim.', 'info');
                    }
                    this.saving=false
                }

        },
        async approveclaim(id){

            const result = await Swal.fire({
                title: 'Are you sure you want to approve this claim?',

                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, approve it!',
            });
            if (result.isConfirmed) {

                const apiToken = localStorage.getItem('token');
                if (apiToken) {
                    // Set the Authorization header with the API token
                    axios.defaults.headers.common['Authorization'] = `Bearer ${apiToken}`;
                }
                try {
                    this.saving=true
                    const res = await axios.post(`${URL.BASEURL}/api/approve-claim/${id}`,{
                        manager_notes: this.selected_claim.manager_notes,
                        claim_amount: this.selected_claim.claim_amount,
                        cashier_id: this.selected_claim.cashier_id,
                        approved_items: this.approved_items
                    });


                    if (res) {

                        // this.claims.data= this.claims.data.map((c)=>{
                        //    if(c.id===res.id) {
                        //        return res
                        //    } else {
                        //        return c
                        //    }
                        // })
                        this.claim_modal=false
                        this.selected_claim=null

                        Swal.fire('success', 'Claim Approved', 'success');
                        await  this.get_claims()

                    } else {
                        Swal.fire('info', 'Claim Cant be Approved', 'info');
                    }
                } catch (error) {
                    console.error(error);
                    Swal.fire('Error', 'Failed to Approve Claim.', 'info');
                }
                this.saving=false
            }

        },
        async completeclaim(id){



            const result = await Swal.fire({
                title: `Are you sure? You want to complete this claim.`,
                text: 'This action cannot be undone.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, complete it!',
            });
            if (result.isConfirmed) {

                const apiToken = localStorage.getItem('token');
                if (apiToken) {
                    // Set the Authorization header with the API token
                    axios.defaults.headers.common['Authorization'] = `Bearer ${apiToken}`;
                }
                try {
                    this.saving=true
                    const res = await axios.post(`${URL.BASEURL}/api/complete-claim/${id}`,{
                        manager_notes: this.selected_claim.manager_notes,
                        claim_amount: this.selected_claim.claim_amount,
                        cashier_id: this.selected_claim.cashier_id,
                        approved_items: this.approved_items
                    });


                    if (res) {

                        // this.claims.data= this.claims.data.map((c)=>{
                        //    if(c.id===res.id) {
                        //        return res
                        //    } else {
                        //        return c
                        //    }
                        // })

                        this.claim_modal=false
                        this.selected_claim=null
                        Swal.fire('success', 'Claim Approved', 'success');
                        await  this.get_claims()

                    } else {
                        Swal.fire('info', 'Claim Cant be Approved', 'info');
                    }
                } catch (error) {
                    console.error(error);
                    Swal.fire('Error', 'Failed to Approve Claim.', 'info');
                }
                this.saving=false
            }

        },
        async deleteclaim(id){

            const result = await Swal.fire({
                title: 'Are you sure you want to delete this claim?',
                text: 'This action cannot be undone.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!',
            });
            if (result.isConfirmed) {

                const apiToken = localStorage.getItem('token');
                if (apiToken) {
                    // Set the Authorization header with the API token
                    axios.defaults.headers.common['Authorization'] = `Bearer ${apiToken}`;
                }
                try {
                    this.saving=true
                    const res = await axios.delete(`${URL.BASEURL}/api/delete-claim/${id}`);

                    if (res) {
                        this.claims.data= this.claims.data.filter((c)=>c.id!==id)

                        Swal.fire('success', 'Claim  Deleted', 'success');

                    } else {
                        Swal.fire('info', 'Claim Cant be Deleted', 'info');
                    }
                } catch (error) {
                    console.error(error);
                    Swal.fire('Error', 'Failed to delete Claim.', 'info');
                }
                this.saving=false
            }

        },

      async  create_invoice(claim){


            let claim_id=claim.id
            const { data } = await apiService.get(`/get_claim_updated_at/${claim_id}`);
            console.log(claim.updated_at,'claim.updated_at')
            console.log(data.updated_at,'data.updated_at')
            if (claim.updated_at !== data.updated_at) {
                const result = await Swal.fire({
                    title: "This claim is updated from another machine/tab",
                    text: "Please reload it.",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes, Reload",
                    cancelButtonText: "No, Let me check",
                });

                if (result.isConfirmed) {
                   await this.get_claims()
                    return;
                } else {

                    return;
                }
            }


            let newinv = cloneDeep(newinvoice);
            newinv.claim_id=claim.id;
            let subTotal = claim.approved_claim_items.reduce(
                (acc, item) => acc + Number(item.sub_total || 0),
                0
            );

            let vat = subTotal * 0.2;
            let grandTotal = subTotal + vat;

            newinv.subTotal = Number(subTotal.toFixed(2));
            newinv.vat = Number(vat.toFixed(2));
            newinv.grandTotal = Number(grandTotal.toFixed(2));

            this.updateFullInvoice(newinv);
            this.attachinvoicenotes([]);
            this.add_dis_items([]);
            this.attach_invoice_transactions([]);


            this.attachapprovedclaimitems(claim.approved_claim_items.map((d)=>{
                let mapid=Math.random()
                return { ...d, qty: d.qty,itemCode: d.item_code,id: d.item_id, original_price: d.original_price,picked:0, itemDescription: d.item_description, mapid:mapid, defaultPrice:d.unit_price};


            }))
            this.$store.commit('customers/setSelectedCustomer', claim.invoice.customer)
            this.setNewpayment({
                "invoice_id":null,
                "invoice_ref":null,
                "cashier_id":null,
                "payment_type": null,
                "reference":null,
                "payment_amount":0,
                "date":null
            })

            this.$router.push({ path: '/' })

        },

        showmodal(claim, is_view_only=false){
            this.selected_claim=claim
            this.is_view_only =is_view_only
            this.claim_modal = ! this.claim_modal
            if (this.selected_claim && this.selected_claim.approved_claim_items && this.selected_claim.approved_claim_items.length > 0) {
                this.approved_items = cloneDeep(this.selected_claim.approved_claim_items).map((item)=>({
                    item_id:item.item_id,
                    broken_tiles:item.broken_tiles,
                    itemCode: item.item_code,
                    itemDescription: item.item_description,
                    quantity: item.qty,
                    unitPrice: item.unit_price,
                    subtotal: item.sub_total
                }));
            } else if (this.selected_claim && this.selected_claim.invoice && this.selected_claim.invoice.items) {
                this.approved_items = this.selected_claim.invoice.items.map(item => ({
                    item_id:item.pivot.item_id,
                    itemCode: item.pivot.itemCode,
                    itemDescription: item.pivot.itemDescription,
                    quantity: item.pivot.quantity,
                    unitPrice: item.pivot.unitPrice,
                    subtotal: item.pivot.subtotal
                }));
            } else {
                this.approved_items = [];
            }
        },


        addApprovedItem() {
            this.approved_items.push({
                itemCode: '',
                itemDescription: '',
                quantity: 0,
                unitPrice: 0,
                subtotal: 0
            });
        },

        removeApprovedItem(index) {
            this.approved_items.splice(index, 1);
        },

        updateApprovedItem(index) {
            const item = this.approved_items[index];
            if (item.itemCode) {
                // Check for duplicate
                const duplicateIndex = this.approved_items.findIndex((i, idx) => i.itemCode === item.itemCode && idx !== index);
                if (duplicateIndex !== -1) {
                    Swal.fire('Error', 'This item is already added.', 'error');
                    item.itemCode = '';
                    item.itemDescription = '';
                    item.unitPrice = 0;
                    item.quantity = 0;
                    item.subtotal = 0;
                    return;
                }

                const invoiceItem = this.selected_claim.invoice.items.find(i => i.pivot.itemCode === item.itemCode);
                if (invoiceItem) {
                    item.original_price=invoiceItem.defaultPrice
                    item.max_discount=invoiceItem.max_discount
                    item.item_id = invoiceItem.pivot.item_id;
                    item.itemDescription = invoiceItem.pivot.itemDescription;
                    item.unitPrice = invoiceItem.pivot.unitPrice;
                    item.quantity = invoiceItem.pivot.quantity;
                    this.calculateItemSubtotal(index);
                } else {
                    Swal.fire('Error', 'Item not found in invoice.', 'error');
                    item.itemCode = '';
                }
            }
        },


        calculateItemSubtotal(index) {
            const item = this.approved_items[index];
            item.subtotal = (Number(item.quantity) * Number(item.unitPrice)).toFixed(2);
        },


        updatenewTransactionDisItems(order,distransaction_history) {
            const allDispatchItems = cloneDeep(distransaction_history).filter((th)=>th.status!='Approved')
                .map(obj => obj.dispatchitems) // Extract dispatchitems from each object
                .reduce((acc, items) => acc.concat(items), []); // Concatenate all dispatchitems into a single array

            // console.log(allDispatchItems,'disable');
            this.newtransaction.dis_items = this.newtransaction.dis_items.map((nt) => {

                const matchedItem = this.searched_items.find((i) =>
                    i.itemCode === nt.itemCode && i.itemDescription === nt.itemDescription
                );

                if (matchedItem) {
                    let pendingqty=allDispatchItems
                        .filter(ad => ad.itemCode === matchedItem.itemCode && ad.itemDescription === matchedItem.itemDescription)
                        .reduce((total, ad) => total + Number(ad.qty), 0);
                    const picked = Number(matchedItem.picked);
                    const qty = Number(matchedItem.qty);
                    const remaining_to_add = qty - picked - pendingqty;


                    if(order.refund!=1){
                        const picked = Number(matchedItem.picked);
                        const qty = Number(matchedItem.qty);
                        const remaining_to_add = qty - picked - pendingqty;

                        return {
                            ...nt,
                            qty: Number(remaining_to_add).toFixed(2),
                        };
                    } else {

                        const qty = Number(matchedItem.qty)+Number((order.orginal_items.filter(oi=>oi.itemCode===matchedItem.itemCode && oi.itemDescription ===matchedItem.itemDescription))[0].picked)-Number(matchedItem.picked);

                        const remaining_to_add = qty  - pendingqty;
                        return {
                            ...nt,
                            qty: Number(remaining_to_add).toFixed(2),
                        };
                    }
                }


                return nt;
            });




            // allDispatchItems.forEach(d => {
            //     this.newtransaction.dis_items.forEach(sd => {
            //         if (sd.itemCode === d.itemCode && sd.itemDescription === d.itemDescription) {
            //             sd.qty = Number(sd.qty) + Number(d.qty);
            //         }
            //     });
            // });
        },

       async loadorder(invoice_id) {
            this.loading_order=true
            this.saving=true

            let order= await this.getLatestInvoices({
                invoice_ref:invoice_id,
                page:1,
                displaypage:'orders'

            });

           this.saving=false
           this.loading_order=true

           order=order.data[0]
           console.log(order,'order')

            this.updateFullInvoice(order)

            this.attachinvoiceitems(order.items)
            let dispatchingitems=cloneDeep(order.items)
            let disitems=dispatchingitems.map((d)=>{

                return { ...d, qty: 0, itemDescription:d.pivot.itemDescription};
            })
            this.add_dis_items(disitems)

            this.attachinvoicenotes(order.notes)
            this.attach_invoice_transactions(order.transactions)
            //  console.log(order)
            this.$store.commit('customers/setSelectedCustomer', order.customer)
            this.setNewpayment({
                "invoice_id":null,
                "invoice_ref":null,
                "cashier_id":null,
                "payment_type": null,
                "reference":null,
                "payment_amount":0,
                "date":null
            })
           this.updatenewTransactionDisItems(order,order.transactions)


            this.$router.push({ path: '/' })
            //  this.togglorderemodal()

        },




        formatDate(date){
            let date1 = new Date(date)
            let date2 =  moment(date1).format('D MMMM, YYYY');

            return date2;
        },
        async signOut() {
            await this.processLogoutManual();
            // await this.$router.push({ name: "Login" });
            window.location.href = this.$router.resolve({ name: "Login" }).href;
        },
        async getUsers(role = '') {
            const { data } = await this.$axios.get(`user?role=${role}`);
            this.items = data;
        },
        async getRoles() {
            const { data } = await this.$axios.get('role');
            this.roles = data.roles;
        },
        filterUsers(value) {
            this.getUsers(value)
        },


        async reloadcb(){
            if(this.branches.length==0){

                //   alert(this.branches.length)
                await this.getbranches()
                // console.log(this.latestinvoices.data.length,'here')

            }
            if(this.cashiers.length==0){


                await this.getcashiers()


            }

        },

        async get_paged_data(button){
            let current_page= this.claims.current_page
            this.claimfilters.page=current_page



            if(button=='next'){

                this.claimfilters.page=current_page+1

                await   this.get_claims()

            }
            if(button=='prev'){
                this.claimfilters.page=current_page-1

                await  this.get_claims()


            }

        },
        async  get_claims() {
            let user = localStorage.getItem('user');
            user=  JSON.parse(user)
            const apiToken = localStorage.getItem('token');
            let url=`${URL.BASEURL}/api/claims`
            let filters ={
                name:this.claimfilters.customer_name,
                telephone:this.claimfilters.phone_number,
                status:this.claimfilters.status,
                order_id:this.claimfilters.order_id,

                page:this.claimfilters.page,


            };
            if(user.permissions.includes('super')){

                filters.branch_id=this.claimfilters.branch_id;

            } else {
                filters.branch_id=user.branch.id;
            }
            this.showloader=true
            try {
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apiToken}`
                    },
                    body: JSON.stringify(filters)
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const res = await response.json();
                this.claims=res
                // console.log('customers:', res);
            } catch (error) {
                console.error('Error:', error);
            }
            this.showloader=false
        }

    },
}
</script>

<style scoped>
@import '../../../assets/styles/pos.css';
.hide {
    visibility: hidden !important;
}


.saving-dots {

    align-items: center;
}

.saving-dots span {
    width: 6px;   /* dot size */
    height: 6px;
    margin: 0 3px;
    background: white;   /* adjust to match button text color */
    border-radius: 50%;
    display: inline-block;
    animation: bounce 1.2s infinite;
}

.saving-dots span:nth-child(1) { animation-delay: 0s; }
.saving-dots span:nth-child(2) { animation-delay: 0.2s; }
.saving-dots span:nth-child(3) { animation-delay: 0.4s; }

.icon-box {
    width: 48px;
    height: 48px;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.icon-box.text-success {
    background: rgba(40, 167, 69, 0.1);
}

.icon-box.text-danger {
    background: rgba(220, 53, 69, 0.1);
}

.card.bg-light {
    background-color: #f8f9fa !important;
    border-radius: 12px;
}

.font-weight-semi-bold {
    font-weight: 600;
}



</style>
